import { IAppState } from "../../../app/appTypes"
import { IChat } from "../../../features/chat/state/chatTypes"
import { IMessage, IMessageAsset } from "../../../features/message/state/messageTypes"

export const getAllChatIds = (state: IAppState): string[] => state.entities.chats.allIds

export const getChatById = (state: IAppState, ownProps: { chatId: string }): IChat =>
  state.entities.chats.byId[ownProps.chatId]

export const getMessageById = (state: IAppState, ownProps: { messageId: string }): IMessage =>
  state.entities.messages.byId[ownProps.messageId]

export const getMessageAssetById = (state: IAppState, ownProps: { messageAssetId: string }): IMessageAsset =>
  state.entities.messageAssets.byId[ownProps.messageAssetId]
